<template>
  <div id="app">
    <div v-if="$route.name === 'Home'" class="halloween-pumpkins">
      <button
        v-for="(pumpkin, index) in halloweenPumpkins"
        :key="`halloween-pumpkin-${index}`"
        type="button"
        class="halloween-pumpkin"
        :class="[`pumpkin-${index + 1}`, { 'has-face': pumpkin.hasFace, 'is-lit': pumpkin.lit }]"
        :aria-label="pumpkin.hasFace ? (pumpkin.lit ? '熄滅南瓜燈' : '點燃南瓜燈') : '裝飾南瓜'"
        :aria-pressed="pumpkin.hasFace ? (pumpkin.lit ? 'true' : 'false') : null"
        :tabindex="pumpkin.hasFace ? 0 : -1"
        @click.stop="toggleHalloweenPumpkin(pumpkin)"
      >
        <span v-if="pumpkin.hasBat" class="halloween-bat" aria-hidden="true"><i></i></span>
        <span v-if="pumpkin.hasHat" class="halloween-witch-hat" aria-hidden="true"><i></i></span>
        <span class="halloween-pumpkin-stem" aria-hidden="true"></span>
        <span class="halloween-pumpkin-body" aria-hidden="true">
          <span v-if="pumpkin.hasFace" class="halloween-pumpkin-face">
            <i class="halloween-pumpkin-eye eye-left"></i>
            <i class="halloween-pumpkin-eye eye-right"></i>
            <i class="halloween-pumpkin-mouth"></i>
          </span>
        </span>
      </button>
    </div>
    <button
      v-if="mummyGameAvailable"
      class="mummy-game-toggle"
      type="button"
      :class="{ 'is-active': mummyGameActive }"
      :aria-pressed="mummyGameActive ? 'true' : 'false'"
      @click="toggleMummyGame"
    >
      <span class="mummy-game-toggle-icon" aria-hidden="true"></span>
      {{ mummyGameActive ? '結束任務' : '開始任務' }}
    </button>
    <div
      v-if="mummyGameActive"
      class="mummy-game-guard"
      aria-hidden="true"
      @click.stop
      @dblclick.stop
      @contextmenu.prevent
      @wheel.prevent
    ></div>
    <loading :active.sync="isLoading"></loading>
    <Navbar v-if="authorized && $route.name !== 'Biztalk'&& !shouldHideHeader" />
    <main>
      <router-view style="min-height: 50vh;" :idleTime="count" v-on:isIdle="checkIdle" :key="!forceRemountRoutes.includes($route.name) ? $route.fullPath : null" :class="{'main-info':authorized && !shouldHideHeader }"/>
    </main>
    <Footer v-if="$route.name !== 'Mag' && $route.name !== 'Biztalk' && !shouldHideHeader" />
    <Announcement v-if="authorized && !isHide && magEnable === false && !shouldHideHeader"/>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import Announcement from '@/components/Announcement.vue'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'App',
  data () {
    return {
      // isLoading: true,
      autoLogout: 30,
      count: 0,
      laserHoldDot: null,
      laserTrailCanvas: null,
      laserTrailContext: null,
      laserTrailAnimationFrame: null,
      laserTrailPoints: [],
      laserTrailDuration: 3000,
      laserPointerDown: false,
      laserPoint: null,
      skipNextLaserPointerUp: false,
      mummyWalkTimer: null,
      mummyInitialTimer: null,
      mummyGameActive: false,
      mummyGameAvailable: document.body.classList.contains('classMummy'),
      mummyPreviousBodyOverflow: '',
      mummyWorldStartedAt: null,
      mummyPyramidCompleteTimer: null,
      mummyPyramid: null,
      mummyPyramidFinished: false,
      mummyPyramidScore: 0,
      mummyMonsterLimit: 6,
      mummyDefeatCount: 0,
      pendingAnubisCount: 0,
      halloweenCandyColorIndex: 0,
      halloweenPumpkins: [
        { hasFace: true, hasHat: true, hasBat: false, lit: false },
        { hasFace: false, hasHat: false, hasBat: false, lit: false },
        { hasFace: true, hasHat: false, hasBat: true, lit: false },
        { hasFace: true, hasHat: true, hasBat: false, lit: false },
        { hasFace: false, hasHat: false, hasBat: true, lit: false },
        { hasFace: true, hasHat: true, hasBat: false, lit: false },
        { hasFace: false, hasHat: false, hasBat: false, lit: false },
        { hasFace: true, hasHat: false, hasBat: true, lit: false },
        { hasFace: true, hasHat: true, hasBat: false, lit: false },
        { hasFace: false, hasHat: false, hasBat: true, lit: false }
      ],
      forceRemountRoutes: ['ai_assistantIntro', 'ai_assistantMain', 'ai_assistant_correction', 'ai_assistant_follow', 'viewGenerate', 'chat', 'chat_history', 'viewChat', 'conversation_rating', 'records']
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'authorized',
      'authInfo'
    ]),
    shouldHideHeader() {
      return this.$route.matched.some(r => r.meta.hideHeader)
    },
    magOnly () {
      if(this.authInfo.user.magOnly === true) {
        return true
      } else {
        return false
      }
    },
    magEnable () {
      if(this.authInfo.user.magEnable === true) {
        return true
      } else {
        return false
      }
    },
    isHide () {
      let arr = ['CourseLesson', 'chat', 'ai_assistantIntro', 'ai_assistantMain', 'chat_history', 'conversation_rating', 'ai_assistant_correction', 'ai_assistant_follow']

      if (arr.indexOf(this.$route.name) > -1) {
        return true
      }
      // return this.$route.name === 'CourseLesson'
    }
  },
  watch: {
    $route () {
      this.stopLaserPointerEffect()
      this.destroyLaserTrailCanvas()
      window.setTimeout(this.syncMummyGameAvailability, 0)
    }
  },
  components: {
    Navbar,
    Loading,
    Footer,
    Announcement
  },
  beforeDestroy () {
    document.removeEventListener('pointerdown', this.showSuperEyeEffect, true)
    document.removeEventListener('pointerdown', this.showHalloweenCandyEffect, true)
    document.removeEventListener('pointerdown', this.showLaserPointerEffect, true)
    document.removeEventListener('pointermove', this.dragLaserPointerEffect, true)
    document.removeEventListener('pointerup', this.stopLaserPointerEffect, true)
    document.removeEventListener('pointercancel', this.stopLaserPointerEffect, true)
    window.removeEventListener('blur', this.stopLaserPointerEffect)
    window.removeEventListener('resize', this.resizeLaserTrailCanvas)
    this.stopLaserPointerEffect()
    this.destroyLaserTrailCanvas()
    document.querySelectorAll('.super-eye-effect').forEach(effect => effect.remove())
    if (this.mummyGameActive) {
      document.body.style.overflow = this.mummyPreviousBodyOverflow
    }
    window.clearTimeout(this.mummyWalkTimer)
    window.clearTimeout(this.mummyInitialTimer)
    window.clearTimeout(this.mummyPyramidCompleteTimer)
    document.querySelectorAll('.super-mummy').forEach(mummy => mummy.remove())
    this.destroyMummyPyramid()
    this.clearTimer()
  },
  mounted () {
    this.$gtm.enabled()
    this.syncMummyGameAvailability()
    document.addEventListener('pointerdown', this.showSuperEyeEffect, true)
    document.addEventListener('pointerdown', this.showHalloweenCandyEffect, true)
    document.addEventListener('pointerdown', this.showLaserPointerEffect, true)
    document.addEventListener('pointermove', this.dragLaserPointerEffect, true)
    document.addEventListener('pointerup', this.stopLaserPointerEffect, true)
    document.addEventListener('pointercancel', this.stopLaserPointerEffect, true)
    window.addEventListener('blur', this.stopLaserPointerEffect)
    window.addEventListener('resize', this.resizeLaserTrailCanvas)
    this.mummyInitialTimer = window.setTimeout(this.scheduleNextMummyWave, 700)
    document.onmousemove = (event) => {
      let x1 = event.clientX
      let y1 = event.clientY
      if (this.x !== x1 || this.y !== y1) {
        this.count = 0
      }
      this.x = x1
      this.y = y1
    }
    document.onkeydown = () => {
      this.count = 0
    }
    document.onscroll = () => {
      this.count = 0
    }
    this.setTimer()
  },
  methods: {
    ...mapActions({
      dologout: 'logout'
    }),
    toggleHalloweenPumpkin (pumpkin) {
      if (!document.body.classList.contains('classHalloween')) {
        return
      }
      if (!pumpkin.hasFace) {
        return
      }
      pumpkin.lit = !pumpkin.lit
    },
    showHalloweenCandyEffect (event) {
      if (event.button !== 0 || !document.body.classList.contains('classHalloween')) {
        return
      }

      const colors = ['blue', 'red', 'yellow']
      const candy = document.createElement('span')
      candy.className = `halloween-candy-click is-${colors[this.halloweenCandyColorIndex]}`
      candy.style.left = `${event.clientX}px`
      candy.style.top = `${event.clientY}px`
      candy.innerHTML = '<i></i>'
      document.body.appendChild(candy)
      this.halloweenCandyColorIndex = (this.halloweenCandyColorIndex + 1) % colors.length
      candy.addEventListener('animationend', () => candy.remove(), { once: true })
    },
    clearTimer () {
      clearInterval(window.myTimer)
      window.myTimer = null
    },
    setTimer () {
      this.count = 0
      if (!window.myTimer) {
        window.myTimer = window.setInterval(this.cookieTimeout, 1000)
      }
    },
    cookieTimeout () {
      let outTime = this.autoLogout
      this.count++
      if (this.count === outTime * 60) {

      }
      if (this.count === outTime * 60) {
        setTimeout(this.logout, 10000)
      }
    },
    logout () {
      if (this.count >= this.autoLogout * 30) {
        if (this.magOnly) {
          this.$router.push({ name: 'Mag' })
        } else {
          this.$router.push({ name: 'Login' })
        }
        this.$swal({
          title: '您已閒置30分鐘，已被登出',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: '確定',
          customClass: {
            confirmButton: 'btn btn-danger'
          }
        })
        this.dologout()
      }
    },
    checkIdle (val) {
      if (val === 'playing') {
        this.clearTimer()
      } else {
        this.setTimer()
      }
    },
    toggleMummyGame () {
      if (this.mummyGameActive) {
        this.setMummyGameActive(false)
        return
      }
      if (!document.body.classList.contains('classMummy')) {
        return
      }

      this.$swal({
        title: '🏺 守護金字塔',
        html: `
          <div class="mummy-rules-copy">
            <p>沉睡千年的木乃伊甦醒了！<br>牠們正一步步逼近金字塔，你的任務就是——<strong>阻止木乃伊的進攻，守護金字塔！</strong></p>
            <p>但攻擊前可要看仔細了！</p>
            <p>👻 <strong>梅傑德神</strong>偶爾會出現在戰場上。<br>祂看起來就像披著白色床單、露出一雙眼睛的神祕生物，<strong>千萬不要誤傷祂！</strong></p>
            <p>⚠️ <strong>等等……事情沒這麼簡單！</strong><br>有些狡猾的木乃伊竟然學會了偽裝，會<strong>假扮成梅傑德神混進來</strong>！</p>
            <p>仔細觀察、分辨真假，擊退真正的木乃伊。</p>
            <p class="mummy-rules-final"><strong>別讓金字塔陷落，也別誤傷真正的梅傑德神！</strong></p>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: '開始任務',
        cancelButtonText: '取消',
        buttonsStyling: false,
        customClass: {
          popup: 'mummy-rules-popup',
          htmlContainer: 'mummy-rules-content',
          confirmButton: 'mummy-rules-start',
          cancelButton: 'mummy-rules-cancel'
        }
      }).then(result => {
        if (result.isConfirmed && document.body.classList.contains('classMummy') && !this.mummyGameActive) {
          this.setMummyGameActive(true)
        }
      })
    },
    setMummyGameActive (isActive) {
      this.mummyGameActive = isActive
      this.mummyWorldStartedAt = null
      window.clearTimeout(this.mummyWalkTimer)

      if (this.mummyGameActive) {
        this.mummyPreviousBodyOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        if (document.activeElement && document.activeElement.blur) {
          document.activeElement.blur()
        }
        this.runMummyWorld()
      } else {
        document.body.style.overflow = this.mummyPreviousBodyOverflow
        document.querySelectorAll('.super-mummy').forEach(mummy => mummy.remove())
        document.querySelectorAll('.super-eye-effect').forEach(effect => effect.remove())
        this.destroyMummyPyramid()
      }

      this.scheduleNextMummyWave()
    },
    syncMummyGameAvailability () {
      this.mummyGameAvailable = document.body.classList.contains('classMummy')
      if (!this.mummyGameAvailable && this.mummyGameActive) {
        this.setMummyGameActive(false)
      }
    },
    showSuperEyeEffect (event) {
      if (!this.mummyGameActive || event.button !== 0) {
        return
      }

      const clickedMummy = event.target.closest && event.target.closest('.super-mummy')
      const clickedContent = event.target.closest && event.target.closest('a, button, input, textarea, select, label, img, video, audio, canvas, svg, p, h1, h2, h3, h4, h5, h6, li, td, th, .card, .picture, .announcement, .navbar, .footer')

      if (!clickedMummy && clickedContent) {
        return
      }

      if (clickedMummy) {
        if (clickedMummy.classList.contains('is-dissolving') || clickedMummy.classList.contains('is-cheering')) {
          return
        }
        if (clickedMummy.classList.contains('super-anubis')) {
          this.changeMummyScore(1)
          this.hitAnubis(clickedMummy)
        } else if (clickedMummy.classList.contains('super-medjed')) {
          if (clickedMummy.classList.contains('is-angry')) {
            this.revealAngryMummy(clickedMummy)
          } else {
            this.changeMummyScore(-1)
            this.consumeMummyPyramidBlock(clickedMummy, 1, true)
            this.dissolveMummy(clickedMummy)
          }
        } else {
          this.changeMummyScore(clickedMummy.classList.contains('is-angry') ? 2 : 1)
          this.dissolveMummy(clickedMummy)
        }
      }

      const effect = document.createElement('span')
      effect.className = 'super-eye-effect'
      effect.style.left = `${event.clientX}px`
      effect.style.top = `${event.clientY}px`
      const symbol = clickedMummy
        ? '<span class="super-ankh-symbol"><span class="super-ankh-loop"></span><span class="super-ankh-cross"></span><span class="super-ankh-stem"></span></span>'
        : '<span class="super-eye-brow"></span><span class="super-eye-symbol"><span class="super-eye-pupil"></span><span class="super-eye-mark"></span><span class="super-eye-tail"></span></span>'
      effect.innerHTML = `<span class="super-eye-halo"></span>${symbol}`
      document.body.appendChild(effect)

      effect.addEventListener('animationend', () => effect.remove(), { once: true })
    },
    changeMummyScore (points) {
      this.mummyPyramidScore += points
      this.mummyMonsterLimit = Math.max(
        this.mummyMonsterLimit,
        6 + Math.floor(Math.max(0, this.mummyPyramidScore) / 20)
      )
      if (!this.mummyPyramid) {
        return
      }

      const score = this.mummyPyramid.querySelector('.pyramid-score')
      const scarabJewel = this.mummyPyramid.querySelector('.pyramid-scarab-jewel')
      if (score) {
        score.textContent = this.mummyPyramidScore
      }
      if (scarabJewel) {
        scarabJewel.classList.remove('is-gain', 'is-loss')
        void scarabJewel.offsetWidth
        scarabJewel.classList.add(points < 0 ? 'is-loss' : 'is-gain')
      }
    },
    revealAngryMummy (medjed) {
      const medjedBody = medjed.querySelector('.medjed-body')
      if (medjedBody) {
        const bounds = medjedBody.getBoundingClientRect()
        const releasedShell = medjedBody.cloneNode(true)
        releasedShell.className = 'medjed-body medjed-released-shell'
        releasedShell.querySelectorAll('.medjed-leg, .mummy-angry-mark').forEach(part => part.remove())
        releasedShell.style.left = `${bounds.left}px`
        releasedShell.style.top = `${bounds.top}px`
        releasedShell.style.width = `${bounds.width}px`
        releasedShell.style.height = `${bounds.height}px`
        document.body.appendChild(releasedShell)
        releasedShell.addEventListener('animationend', () => releasedShell.remove(), { once: true })
      }

      medjed.classList.remove('super-medjed')
      medjed.classList.add('curse-revealed')
      medjed.innerHTML = '<span class="mummy-shadow"></span><span class="mummy-head"><span class="mummy-eyes"></span><span class="mummy-angry-mark"><i></i><i></i><i></i><i></i></span></span><span class="mummy-body"><span class="mummy-bandages"></span></span><span class="mummy-arm mummy-arm-front"></span><span class="mummy-arm mummy-arm-back"></span><span class="mummy-leg mummy-leg-front"></span><span class="mummy-leg mummy-leg-back"></span>'
      window.setTimeout(() => medjed.classList.remove('curse-revealed'), 500)
    },
    dissolveMummy (mummy) {
      if (mummy.classList.contains('is-dissolving')) {
        return
      }

      const bounds = mummy.getBoundingClientRect()
      mummy.style.left = `${bounds.left}px`
      mummy.style.top = `${bounds.top}px`
      mummy.style.bottom = 'auto'
      if (mummy.classList.contains('walks-left')) {
        mummy.classList.add('facing-left')
      }
      if (Math.random() < 0.5) {
        mummy.classList.add('falls-forward')
      }
      mummy.classList.remove('walks-left', 'walks-right')

      if (mummy.classList.contains('super-medjed')) {
        const poisonHaze = document.createElement('span')
        poisonHaze.className = 'medjed-poison-haze'
        mummy.appendChild(poisonHaze)

        for (let index = 0; index < 6; index++) {
          const smoke = document.createElement('span')
          smoke.className = 'medjed-poison-smoke'
          smoke.style.left = `${12 + Math.random() * 31}px`
          smoke.style.bottom = `${12 + Math.random() * 17}px`
          smoke.style.setProperty('--smoke-x', `${Math.round((Math.random() - 0.5) * 42)}px`)
          smoke.style.setProperty('--smoke-y', `${Math.round(-28 - Math.random() * 28)}px`)
          smoke.style.setProperty('--smoke-delay', `${(0.45 + index * 0.13 + Math.random() * 0.12).toFixed(2)}s`)
          smoke.style.setProperty('--smoke-scale', `${(1.05 + Math.random() * .45).toFixed(2)}`)
          mummy.appendChild(smoke)
        }
      } else {
        for (let index = 0; index < 22; index++) {
          const grain = document.createElement('span')
          grain.className = 'mummy-sand-grain'
          grain.style.left = `${8 + Math.random() * 34}px`
          grain.style.top = `${16 + Math.random() * 55}px`
          grain.style.setProperty('--sand-x', `${Math.round((Math.random() - 0.5) * 80)}px`)
          grain.style.setProperty('--sand-y', `${30 + Math.round(Math.random() * 48)}px`)
          grain.style.setProperty('--sand-delay', `${(1.65 + Math.random() * 0.5).toFixed(2)}s`)
          mummy.appendChild(grain)
        }
      }

      mummy.classList.add('is-dissolving')
      if (!mummy.classList.contains('super-anubis')) {
        this.mummyDefeatCount++
        if (this.mummyDefeatCount % 10 === 0) {
          this.pendingAnubisCount++
          window.setTimeout(this.createAnubisWalker, 450)
        }
      }
    },
    hitAnubis (anubis) {
      if (anubis.classList.contains('is-dissolving')) {
        return
      }

      const hits = Number(anubis.dataset.hits || 0) + 1
      anubis.dataset.hits = hits
      const healthMarks = anubis.querySelectorAll('.anubis-health i')
      if (healthMarks[hits - 1]) {
        healthMarks[hits - 1].classList.add('is-lost')
      }
      anubis.classList.remove('is-hit')
      void anubis.offsetWidth
      anubis.classList.add('is-hit')

      if (hits >= 5) {
        this.dissolveMummy(anubis)
      }
    },
    createAnubisWalker () {
      if (!this.mummyGameActive || this.mummyPyramidFinished || this.pendingAnubisCount < 1 || document.querySelector('.super-anubis')) {
        return
      }

      const anubis = document.createElement('span')
      const walksRight = Math.random() >= 0.5
      const startY = Math.round(window.innerHeight * (0.2 + Math.random() * 0.5))
      const driftY = Math.round((Math.random() - 0.5) * 100)
      anubis.className = `super-mummy super-anubis ${walksRight ? 'walks-right' : 'walks-left'}`
      anubis.style.top = `${startY}px`
      anubis.style.setProperty('--mummy-drift-y', `${driftY}px`)
      const walkDuration = (8 + Math.round(Math.random() * 5)) / 2
      anubis.style.setProperty('--mummy-duration', `${walkDuration}s`)
      anubis.innerHTML = '<span class="mummy-shadow"></span><span class="anubis-figure"><span class="anubis-ear ear-left"></span><span class="anubis-ear ear-right"></span><span class="anubis-head"><span class="anubis-eye"></span><span class="anubis-snout"></span></span><span class="anubis-body"></span><span class="anubis-arm arm-left"></span><span class="anubis-arm arm-right"></span><span class="anubis-leg leg-left"></span><span class="anubis-leg leg-right"></span></span><span class="anubis-health"><i></i><i></i><i></i><i></i><i></i></span>'
      document.body.appendChild(anubis)
      this.pendingAnubisCount--
      this.bindMummyCompletion(anubis)
    },
    getMummySpawnDelay () {
      if (!this.mummyWorldStartedAt) {
        return 2167
      }

      const elapsedMinutes = (Date.now() - this.mummyWorldStartedAt) / 60000
      return Math.max(850, Math.round(2167 * Math.pow(0.92, elapsedMinutes)))
    },
    scheduleNextMummyWave () {
      window.clearTimeout(this.mummyWalkTimer)
      this.mummyWalkTimer = window.setTimeout(() => {
        this.runMummyWorld()
        this.scheduleNextMummyWave()
      }, this.getMummySpawnDelay())
    },
    runMummyWorld () {
      if (!this.mummyGameActive || !document.body.classList.contains('classMummy')) {
        this.mummyGameActive = false
        this.mummyWorldStartedAt = null
        this.destroyMummyPyramid()
        return
      }

      if (!this.mummyWorldStartedAt) {
        this.mummyWorldStartedAt = Date.now()
      }
      this.createMummyPyramid()
      if (!this.mummyPyramidFinished) {
        this.createAnubisWalker()
        this.createMummyWalker()
      }
    },
    createMummyPyramid () {
      if (this.mummyPyramid && document.body.contains(this.mummyPyramid)) {
        return
      }

      this.mummyPyramidFinished = false
      this.mummyPyramidScore = 0
      this.mummyMonsterLimit = 6
      this.mummyPyramid = document.createElement('div')
      this.mummyPyramid.className = 'super-mummy-pyramid'
      this.mummyPyramid.setAttribute('aria-hidden', 'true')

      const scarabJewel = document.createElement('span')
      scarabJewel.className = 'pyramid-scarab-jewel'
      scarabJewel.innerHTML = '<i class="scarab-wing wing-left"></i><i class="scarab-wing wing-right"></i><i class="scarab-body"></i><b class="pyramid-score">0</b>'
      this.mummyPyramid.appendChild(scarabJewel)

      for (let row = 1; row <= 5; row++) {
        const pyramidRow = document.createElement('span')
        pyramidRow.className = 'pyramid-row'
        for (let column = 0; column < row; column++) {
          const block = document.createElement('i')
          block.className = 'pyramid-block'
          pyramidRow.appendChild(block)
        }
        this.mummyPyramid.appendChild(pyramidRow)
      }

      document.body.appendChild(this.mummyPyramid)
    },
    consumeMummyPyramidBlock (completedMummy, forcedDamage = null, isCurseDamage = false) {
      if (!this.mummyPyramid || this.mummyPyramidFinished) {
        return
      }

      const damage = forcedDamage === null
        ? (completedMummy && completedMummy.classList.contains('super-anubis')
            ? 5
            : (completedMummy && completedMummy.classList.contains('is-angry') ? 2 : 1))
        : forcedDamage
      for (let hit = 0; hit < damage; hit++) {
        const block = this.mummyPyramid.querySelector('.pyramid-block:not(.is-removed)')
        if (!block) {
          break
        }

        for (let index = 0; index < 24; index++) {
          const sand = document.createElement('span')
          sand.className = 'pyramid-sand'
          sand.style.left = `${2 + Math.random() * 17}px`
          sand.style.top = `${2 + Math.random() * 10}px`
          sand.style.width = `${1 + Math.round(Math.random() * 2)}px`
          sand.style.height = sand.style.width
          sand.style.setProperty('--pyramid-sand-x', `${Math.round((Math.random() - 0.5) * 42)}px`)
          sand.style.setProperty('--pyramid-sand-y', `${14 + Math.round(Math.random() * 32)}px`)
          sand.style.setProperty('--pyramid-sand-delay', `${(0.85 + Math.random() * 0.5).toFixed(2)}s`)
          sand.style.setProperty('--pyramid-sand-duration', `${(0.85 + Math.random() * 0.55).toFixed(2)}s`)
          block.appendChild(sand)
        }
        if (isCurseDamage) {
          block.classList.add('is-cursed')
        }
        block.classList.add('is-removed')
      }

      if (!this.mummyPyramid.querySelector('.pyramid-block:not(.is-removed)')) {
        this.mummyPyramidFinished = true
        this.mummyPyramidCompleteTimer = window.setTimeout(() => {
          if (this.mummyGameActive && this.mummyPyramid) {
            this.cheerRemainingMummies(completedMummy)
          }
        }, 2300)
      }
    },
    cheerRemainingMummies (completedMummy) {
      document.querySelectorAll('.super-mummy:not(.is-dissolving)').forEach(mummy => {
        if (mummy === completedMummy || mummy.classList.contains('is-cheering')) {
          return
        }

        const bounds = mummy.getBoundingClientRect()
        mummy.style.left = `${bounds.left}px`
        mummy.style.top = `${bounds.top}px`
        mummy.style.bottom = 'auto'
        if (mummy.classList.contains('walks-left')) {
          mummy.classList.add('facing-left')
        }
        mummy.classList.remove('walks-left', 'walks-right')
        mummy.classList.add('is-cheering')
      })
    },
    destroyMummyPyramid () {
      window.clearTimeout(this.mummyPyramidCompleteTimer)
      this.mummyPyramidCompleteTimer = null
      if (this.mummyPyramid) {
        this.mummyPyramid.remove()
        this.mummyPyramid = null
      }
      this.mummyPyramidFinished = false
      this.mummyPyramidScore = 0
      this.mummyMonsterLimit = 6
      this.mummyDefeatCount = 0
      this.pendingAnubisCount = 0
    },
    createMummyWalker () {
      if (!this.mummyGameActive || document.hidden || document.querySelectorAll('.super-mummy').length >= this.mummyMonsterLimit) {
        return
      }

      const mummy = document.createElement('span')
      const walksRight = Math.random() >= 0.5
      const isMedjed = document.body.classList.contains('classMummy') && Math.random() < (1 / 5)
      const isAngryMedjed = isMedjed && Math.random() < 0.5
      const isAngry = isAngryMedjed || (!isMedjed && Math.random() < 0.35)
      const startY = Math.round(window.innerHeight * (0.16 + Math.random() * 0.62))
      const maxDriftUp = Math.max(0, Math.min(130, startY - 90))
      const maxDriftDown = Math.max(0, Math.min(130, window.innerHeight - startY - 110))
      const driftY = Math.round((Math.random() * (maxDriftUp + maxDriftDown)) - maxDriftUp)
      mummy.className = `super-mummy ${walksRight ? 'walks-right' : 'walks-left'}${isAngry ? ' is-angry' : ''}${isMedjed ? ' super-medjed' : ''}`
      mummy.style.top = `${startY}px`
      mummy.style.setProperty('--mummy-drift-y', `${driftY}px`)
      const walkDuration = 8 + Math.round(Math.random() * 5)
      mummy.style.setProperty('--mummy-duration', `${isAngry || isMedjed ? walkDuration / 2 : walkDuration}s`)
      mummy.innerHTML = isMedjed
        ? '<span class="mummy-shadow"></span><span class="medjed-body"><span class="mummy-angry-mark"><i></i><i></i><i></i><i></i></span><span class="medjed-eye eye-left"></span><span class="medjed-eye eye-right"></span><span class="medjed-mouth"></span><span class="medjed-leg leg-left"></span><span class="medjed-leg leg-right"></span></span><span class="medjed-ray ray-left"></span><span class="medjed-ray ray-right"></span>'
        : '<span class="mummy-shadow"></span><span class="mummy-head"><span class="mummy-eyes"></span><span class="mummy-angry-mark"><i></i><i></i><i></i><i></i></span></span><span class="mummy-body"><span class="mummy-bandages"></span></span><span class="mummy-arm mummy-arm-front"></span><span class="mummy-arm mummy-arm-back"></span><span class="mummy-leg mummy-leg-front"></span><span class="mummy-leg mummy-leg-back"></span>'
      document.body.appendChild(mummy)

      this.bindMummyCompletion(mummy)
    },
    bindMummyCompletion (mummy) {
      mummy.addEventListener('animationend', animationEvent => {
        if (animationEvent.target === mummy) {
          if (!mummy.classList.contains('is-dissolving')) {
            if (mummy.classList.contains('super-medjed')) {
              if (mummy.classList.contains('is-angry')) {
                this.consumeMummyPyramidBlock(mummy)
              }
            } else {
              this.consumeMummyPyramidBlock(mummy)
            }
          }
          mummy.remove()
        }
      })
    },
    isLaserPointerExcludedTarget (event) {
      if (!event || !event.target || !event.target.closest) {
        return false
      }

      return Boolean(event.target.closest('img, a, button, input, textarea, select, label, [role="button"], .btn, .button_item, .fixed-top, .navbar_l, .announcement'))
    },
    clearLaserPointerEffect () {
      this.laserPointerDown = false
      document.body.classList.remove('laser-pointer-active')
      this.laserPoint = null
      this.laserTrailPoints = []
      document.querySelectorAll('.laser-pointer-effect').forEach(effect => effect.remove())
      document.querySelectorAll('.laser-pointer-trail-canvas').forEach(canvas => canvas.remove())
      if (this.laserHoldDot) {
        this.laserHoldDot.remove()
        this.laserHoldDot = null
      }
      this.destroyLaserTrailCanvas()
    },
    shouldUseLaserPointerEffect (event) {
      if (!document.body.classList.contains('class04')) {
        return false
      }

      if (event && event.button !== undefined && event.button !== 0) {
        return false
      }

      if (this.isLaserPointerExcludedTarget(event)) {
        return false
      }

      return true
    },
    createLaserPointerEffect (x, y) {
      const effect = document.createElement('span')
      effect.className = 'laser-pointer-effect'
      effect.style.left = `${x}px`
      effect.style.top = `${y}px`
      effect.innerHTML = '<span></span>'
      document.body.appendChild(effect)

      effect.addEventListener('animationend', () => {
        effect.remove()
      })
    },
    updateLaserHoldDot (x, y) {
      if (!this.laserHoldDot) {
        this.laserHoldDot = document.createElement('span')
        this.laserHoldDot.className = 'laser-pointer-hold-dot'
        document.body.appendChild(this.laserHoldDot)
      }

      this.laserHoldDot.style.left = `${x}px`
      this.laserHoldDot.style.top = `${y}px`
    },
    createLaserTrailCanvas () {
      if (this.laserTrailCanvas) {
        return
      }

      this.laserTrailCanvas = document.createElement('canvas')
      this.laserTrailCanvas.className = 'laser-pointer-trail-canvas'
      this.laserTrailContext = this.laserTrailCanvas.getContext('2d')
      document.body.appendChild(this.laserTrailCanvas)
      this.resizeLaserTrailCanvas()
    },
    resizeLaserTrailCanvas () {
      if (!this.laserTrailCanvas || !this.laserTrailContext) {
        return
      }

      const pixelRatio = window.devicePixelRatio || 1
      this.laserTrailCanvas.width = window.innerWidth * pixelRatio
      this.laserTrailCanvas.height = window.innerHeight * pixelRatio
      this.laserTrailContext.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
    },
    appendLaserTrailPoint (x, y) {
      const point = {
        x,
        y,
        time: window.performance.now()
      }
      const lastPoint = this.laserTrailPoints[this.laserTrailPoints.length - 1]

      if (!lastPoint || Math.hypot(point.x - lastPoint.x, point.y - lastPoint.y) > 2) {
        this.laserTrailPoints.push(point)
      }
    },
    startLaserTrailAnimation () {
      if (this.laserTrailAnimationFrame) {
        return
      }

      this.laserTrailAnimationFrame = window.requestAnimationFrame(() => {
        this.drawLaserTrail()
      })
    },
    getLaserTrailAlpha (point, now) {
      return Math.max(0, 1 - ((now - point.time) / this.laserTrailDuration))
    },
    drawSmoothLaserPath (points) {
      const context = this.laserTrailContext

      context.beginPath()
      context.moveTo(points[0].x, points[0].y)

      if (points.length === 2) {
        context.lineTo(points[1].x, points[1].y)
      } else {
        for (let index = 1; index < points.length - 1; index++) {
          const current = points[index]
          const next = points[index + 1]
          const midX = (current.x + next.x) / 2
          const midY = (current.y + next.y) / 2
          context.quadraticCurveTo(current.x, current.y, midX, midY)
        }

        const last = points[points.length - 1]
        context.lineTo(last.x, last.y)
      }

      context.stroke()
    },
    drawLaserTrailLayer (points, now, width, color, shadowColor, shadowBlur) {
      const context = this.laserTrailContext
      const bucketCount = 24
      let currentBucket = null
      let currentPoints = []

      context.lineCap = 'butt'
      context.lineJoin = 'round'
      context.lineWidth = width
      context.shadowColor = shadowColor
      context.shadowBlur = shadowBlur
      context.strokeStyle = color

      for (let index = 1; index < points.length; index++) {
        const previous = points[index - 1]
        const current = points[index]
        const alpha = Math.min(this.getLaserTrailAlpha(previous, now), this.getLaserTrailAlpha(current, now))

        if (alpha <= 0) {
          continue
        }

        const bucket = Math.max(1, Math.ceil(alpha * bucketCount))

        if (currentBucket === null) {
          currentBucket = bucket
          currentPoints = [previous, current]
        } else if (bucket === currentBucket) {
          currentPoints.push(current)
        } else {
          context.globalAlpha = currentBucket / bucketCount
          this.drawSmoothLaserPath(currentPoints)
          currentBucket = bucket
          currentPoints = [previous, current]
        }
      }

      if (currentPoints.length > 1) {
        context.globalAlpha = currentBucket / bucketCount
        this.drawSmoothLaserPath(currentPoints)
      }
    },
    drawLaserTrailCap (point, now, radius, color) {
      const context = this.laserTrailContext
      const alpha = this.getLaserTrailAlpha(point, now)

      if (alpha <= 0) {
        return
      }

      context.globalAlpha = alpha
      context.shadowColor = 'transparent'
      context.shadowBlur = 0
      context.fillStyle = color
      context.beginPath()
      context.arc(point.x, point.y, radius, 0, Math.PI * 2)
      context.fill()
    },
    drawLaserTrail () {
      this.laserTrailAnimationFrame = null

      if (!this.laserTrailCanvas || !this.laserTrailContext) {
        return
      }

      const now = window.performance.now()
      const context = this.laserTrailContext
      this.laserTrailPoints = this.laserTrailPoints.filter(point => now - point.time < this.laserTrailDuration)
      context.clearRect(0, 0, window.innerWidth, window.innerHeight)

      if (this.laserTrailPoints.length > 1) {
        this.drawLaserTrailLayer(this.laserTrailPoints, now, 4, 'rgba(255, 20, 20, .88)', 'rgba(255, 0, 0, .6)', 5)
        this.drawLaserTrailLayer(this.laserTrailPoints, now, 1.4, 'rgba(255, 255, 255, .92)', 'rgba(255, 255, 255, .45)', 3)
        this.drawLaserTrailCap(this.laserTrailPoints[0], now, 2, 'rgba(255, 20, 20, .88)')
        this.drawLaserTrailCap(this.laserTrailPoints[this.laserTrailPoints.length - 1], now, 2, 'rgba(255, 20, 20, .88)')
        this.drawLaserTrailCap(this.laserTrailPoints[0], now, .7, 'rgba(255, 255, 255, .92)')
        this.drawLaserTrailCap(this.laserTrailPoints[this.laserTrailPoints.length - 1], now, .7, 'rgba(255, 255, 255, .92)')
        context.globalAlpha = 1
        context.shadowBlur = 0
      }

      if (this.laserPointerDown || this.laserTrailPoints.length > 0) {
        this.startLaserTrailAnimation()
      } else {
        this.destroyLaserTrailCanvas()
      }
    },
    destroyLaserTrailCanvas () {
      if (this.laserTrailAnimationFrame) {
        window.cancelAnimationFrame(this.laserTrailAnimationFrame)
        this.laserTrailAnimationFrame = null
      }
      if (this.laserTrailCanvas) {
        this.laserTrailCanvas.remove()
        this.laserTrailCanvas = null
        this.laserTrailContext = null
      }
    },
    showLaserPointerEffect (event) {
      if (!this.shouldUseLaserPointerEffect(event)) {
        if (this.isLaserPointerExcludedTarget(event)) {
          this.skipNextLaserPointerUp = true
          this.clearLaserPointerEffect()
        }
        return
      }

      event.preventDefault()
      document.body.classList.add('laser-pointer-active')
      this.laserPointerDown = true
      this.laserPoint = {
        x: event.clientX,
        y: event.clientY
      }
      this.laserTrailPoints = []
      this.createLaserTrailCanvas()
      this.appendLaserTrailPoint(this.laserPoint.x, this.laserPoint.y)
      this.startLaserTrailAnimation()
      this.updateLaserHoldDot(this.laserPoint.x, this.laserPoint.y)
      this.createLaserPointerEffect(this.laserPoint.x, this.laserPoint.y)
    },
    dragLaserPointerEffect (event) {
      if (!this.laserPointerDown) {
        return
      }

      event.preventDefault()
      if (!document.body.classList.contains('class04') || (event.buttons !== undefined && !(event.buttons & 1))) {
        this.stopLaserPointerEffect()
        return
      }

      this.laserPoint = {
        x: event.clientX,
        y: event.clientY
      }
      this.updateLaserHoldDot(this.laserPoint.x, this.laserPoint.y)
      this.appendLaserTrailPoint(this.laserPoint.x, this.laserPoint.y)
      this.startLaserTrailAnimation()
    },
    stopLaserPointerEffect (event) {
      if (this.skipNextLaserPointerUp || this.isLaserPointerExcludedTarget(event)) {
        this.skipNextLaserPointerUp = false
        this.clearLaserPointerEffect()
        return
      }

      if (!this.laserPointerDown) {
        return
      }

      const shouldShowEndEffect = this.laserPointerDown && this.laserPoint && document.body.classList.contains('class04')

      if (shouldShowEndEffect) {
        const x = event && event.clientX !== undefined ? event.clientX : this.laserPoint.x
        const y = event && event.clientY !== undefined ? event.clientY : this.laserPoint.y
        this.createLaserPointerEffect(x, y)
      }

      this.laserPointerDown = false
      document.body.classList.remove('laser-pointer-active')
      this.laserPoint = null
      if (event && event.clientX !== undefined) {
        this.appendLaserTrailPoint(event.clientX, event.clientY)
      }
      this.startLaserTrailAnimation()
      if (this.laserHoldDot) {
        this.laserHoldDot.remove()
        this.laserHoldDot = null
      }
    }
  }
}
</script>

<style lang="scss">
* {
  font-family: Avenir, Helvetica, Arial, sans-serif, 微軟正黑體;
  box-sizing: border-box;
}
#app {
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.mummy-game-toggle {
  position: fixed;
  z-index: 2147483646;
  left: 26px;
  bottom: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 112px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #9a7430;
  border-radius: 6px;
  color: #fff7d5;
  background: #332817;
  box-shadow: 0 2px 7px rgba(25, 17, 8, .32);
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}
.mummy-game-guard {
  position: fixed;
  z-index: 2147483600;
  inset: 0;
  background: rgba(0, 0, 0, .38);
  cursor: default;
  touch-action: none;
  animation: mummyGameGuardIn .25s ease-out;
}
.mummy-game-toggle:hover,
.mummy-game-toggle:focus-visible {
  background: #4b3a1e;
  border-color: #d5aa4c;
  outline: none;
}
.mummy-game-toggle.is-active {
  color: #f5eaff;
  background: #321c3b;
  border-color: #87519a;
}
.mummy-game-toggle-icon {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 9px solid currentColor;
}
.mummy-game-toggle.is-active .mummy-game-toggle-icon {
  width: 10px;
  height: 10px;
  border: 0;
  background: currentColor;
}
.mummy-rules-popup {
  width: min(560px, calc(100vw - 28px)) !important;
  border: 1px solid #b78a38 !important;
  border-radius: 8px !important;
  background: #fffdf5 !important;
  box-shadow: 0 16px 48px rgba(25, 17, 8, .34) !important;
}
.mummy-rules-content {
  margin: 8px 28px 4px !important;
}
.mummy-rules-copy {
  color: #302718;
  font-size: 15px;
  line-height: 1.65;
  text-align: left;
}
.mummy-rules-copy p {
  margin: 0 0 14px;
}
.mummy-rules-copy .mummy-rules-final {
  margin-bottom: 0;
  color: #7a4816;
  text-align: center;
}
.mummy-rules-start,
.mummy-rules-cancel {
  min-width: 112px;
  height: 40px;
  margin: 10px 5px 0;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}
.mummy-rules-start {
  border: 1px solid #8c641f;
  color: #fff8dc;
  background: #3b2b16;
}
.mummy-rules-start:hover,
.mummy-rules-start:focus-visible {
  background: #59401e;
  outline: 2px solid #d3a84e;
  outline-offset: 2px;
}
.mummy-rules-cancel {
  border: 1px solid #a99e87;
  color: #514938;
  background: #f4f0e6;
}
.mummy-rules-cancel:hover,
.mummy-rules-cancel:focus-visible {
  background: #e7e0d1;
  outline: 2px solid #b9a77d;
  outline-offset: 2px;
}
main {
  flex: 1; /* 讓 main 撐開剩餘高度 */
}
.main-info {
  margin: 93px 0 0 0;
  min-height: calc(100vh - 93px);
}
.btn-general {
  border-radius: 20px !important;
  width: 150px;
}
input:focus {
  outline: none;
}

.success {
  font-size: 1.5rem;
  margin-top: 60px;
}
.error {
  text-align: left;
  color: red;
  font-size: .8rem;
}
.super-mummy-pyramid {
  position: fixed;
  z-index: 2147483601;
  left: 18px;
  bottom: 62px;
  width: 128px;
  min-height: 96px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 3px;
  pointer-events: none;
  filter: drop-shadow(0 4px 4px rgba(58, 43, 22, .32));
}
.pyramid-scarab-jewel {
  position: relative;
  display: block;
  width: 66px;
  height: 38px;
  margin-bottom: 2px;
  color: #fff8c8;
  filter: drop-shadow(0 2px 2px rgba(42, 28, 9, .48));
}
.scarab-body {
  position: absolute;
  z-index: 3;
  left: 19px;
  top: 6px;
  width: 28px;
  height: 31px;
  border: 2px solid #d5a63c;
  border-radius: 48% 48% 44% 44%;
  background: radial-gradient(circle at 38% 28%, #75d8c1, #167d78 48%, #10454e 100%);
  box-shadow: inset 0 0 7px rgba(220, 255, 226, .45), 0 0 6px rgba(229, 186, 69, .58);
}
.scarab-body::before {
  content: "";
  position: absolute;
  left: 6px;
  top: -8px;
  width: 12px;
  height: 10px;
  border: 2px solid #d5a63c;
  border-radius: 50% 50% 35% 35%;
  background: #15666c;
}
.scarab-wing {
  position: absolute;
  z-index: 1;
  top: 6px;
  width: 29px;
  height: 24px;
  border: 2px solid #c89531;
  background: linear-gradient(145deg, #f1c75f, #91631d);
  box-shadow: inset 0 0 5px rgba(255, 240, 154, .55);
  overflow: hidden;
}
.scarab-wing::after {
  content: "";
  position: absolute;
  top: 5px;
  width: 24px;
  height: 17px;
  border-top: 2px solid rgba(255, 235, 145, .72);
  border-radius: 50%;
}
.scarab-wing.wing-left {
  left: 0;
  border-radius: 95% 18% 78% 28% / 88% 25% 72% 35%;
  transform: rotate(25deg) translateY(-4px);
  transform-origin: 100% 70%;
}
.scarab-wing.wing-left::after {
  left: 4px;
  transform: rotate(12deg);
}
.scarab-wing.wing-right {
  right: 0;
  border-radius: 18% 95% 28% 78% / 25% 88% 35% 72%;
  transform: rotate(-25deg) translateY(-4px);
  transform-origin: 0 70%;
}
.scarab-wing.wing-right::after {
  right: 4px;
  transform: rotate(-12deg);
}
.pyramid-score {
  position: absolute;
  z-index: 4;
  left: 19px;
  top: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 31px;
  font-size: 12px;
  line-height: 1;
  color: #fff8c8;
  text-shadow: 0 1px 2px #14383d;
}
.pyramid-scarab-jewel.is-gain {
  animation: scarabScoreGain .42s ease-out;
}
.pyramid-scarab-jewel.is-loss {
  animation: scarabScoreLoss .42s ease-out;
}
.pyramid-row {
  display: flex;
  justify-content: center;
  gap: 3px;
  height: 15px;
}
.pyramid-block {
  position: relative;
  display: block;
  width: 21px;
  height: 14px;
  border: 1px solid #816b43;
  background:
    radial-gradient(circle at 25% 32%, rgba(255, 239, 180, .35) 0 1px, transparent 1.5px),
    radial-gradient(circle at 72% 68%, rgba(87, 65, 31, .28) 0 1px, transparent 1.5px),
    linear-gradient(145deg, #d4b86f 0%, #b89550 48%, #876a36 100%);
  box-shadow: inset 1px 1px 1px rgba(255, 239, 190, .35), inset -2px -2px 2px rgba(67, 49, 23, .25), 0 1px 1px rgba(55, 39, 17, .25);
  transform: perspective(30px) rotateX(-4deg);
  transition: opacity .55s ease, transform .55s ease, filter .55s ease;
}
.pyramid-block::after {
  content: "";
  position: absolute;
  left: 2px;
  right: 2px;
  top: 2px;
  height: 1px;
  background: rgba(235, 212, 154, .42);
}
.pyramid-block::before {
  content: "";
  position: absolute;
  z-index: 2;
  inset: 1px;
  opacity: 0;
  background:
    linear-gradient(62deg, transparent 42%, rgba(70, 48, 21, .8) 44% 49%, transparent 51%) 2px 0 / 8px 10px no-repeat,
    linear-gradient(118deg, transparent 43%, rgba(70, 48, 21, .7) 45% 50%, transparent 52%) 10px 3px / 8px 9px no-repeat;
  pointer-events: none;
}
.pyramid-row:nth-child(2n) .pyramid-block:nth-child(2n + 1),
.pyramid-row:nth-child(2n + 1) .pyramid-block:nth-child(2n) {
  background:
    radial-gradient(circle at 68% 30%, rgba(246, 224, 167, .3) 0 1px, transparent 1.5px),
    linear-gradient(155deg, #c8aa65 0%, #a98749 55%, #796039 100%);
}
.pyramid-block.is-removed {
  animation: pyramidBlockCrumble 2.3s ease-in forwards;
}
.pyramid-block.is-removed::before {
  animation: pyramidCracks 2.3s ease-in forwards;
}
.pyramid-block.is-removed.is-cursed {
  box-shadow: inset 0 0 7px rgba(103, 31, 139, .82), 0 0 8px rgba(126, 38, 159, .85);
  animation: pyramidCurseCrumble .72s ease-in forwards;
}
.pyramid-block.is-removed.is-cursed::before {
  animation-duration: .72s;
}
.pyramid-sand {
  position: absolute;
  z-index: 3;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background: #a88649;
  box-shadow: 0 0 1px rgba(86, 62, 27, .45);
  opacity: 0;
  pointer-events: none;
  animation: pyramidSandFall var(--pyramid-sand-duration, 1.1s) var(--pyramid-sand-delay, 0s) ease-in forwards;
}
@keyframes pyramidBlockCrumble {
  0%, 8% { opacity: 1; transform: translate(0, 0) rotate(0) scale(1); filter: none; }
  12% { transform: translate(-2px, 0) rotate(-2deg) scale(1.02); }
  17% { transform: translate(2px, -1px) rotate(2deg) scale(1.02); }
  22% { transform: translate(-2px, 1px) rotate(-1deg) scale(1); }
  27% { transform: translate(2px, 0) rotate(1deg) scale(1.01); }
  33% { opacity: 1; transform: translate(0, 1px) rotate(0) scale(1); }
  58% { opacity: .95; transform: translateY(4px) scale(.92, .78); filter: sepia(.35); }
  78% { opacity: .65; transform: translateY(9px) scale(.7, .42) rotate(5deg); filter: sepia(.75) blur(.5px); }
  100% { opacity: 0; transform: translateY(17px) scale(.28, .08) rotate(10deg); filter: sepia(1) blur(2px); }
}
@keyframes mummyGameGuardIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes pyramidCurseCrumble {
  0% { opacity: 1; transform: translate(0, 0) scale(1); filter: none; }
  22% { opacity: 1; transform: translate(-2px, -1px) rotate(-3deg) scale(1.08); filter: hue-rotate(36deg); }
  46% { opacity: .75; transform: translate(3px, 2px) rotate(4deg) scale(.82); filter: sepia(.4) hue-rotate(220deg); }
  100% { opacity: 0; transform: translateY(12px) rotate(9deg) scale(.18, .08); filter: blur(2px); }
}
@keyframes pyramidCracks {
  0%, 18% { opacity: 0; }
  28%, 62% { opacity: 1; }
  100% { opacity: 0; }
}
@keyframes pyramidSandFall {
  0% { opacity: 0; transform: translate(0, 0) scale(1); }
  18% { opacity: .9; }
  100% { opacity: 0; transform: translate(var(--pyramid-sand-x), var(--pyramid-sand-y)) scale(.25); }
}
@keyframes scarabScoreGain {
  0% { transform: scale(1); filter: drop-shadow(0 2px 2px rgba(42, 28, 9, .48)); }
  35% { transform: scale(1.15) rotate(3deg); filter: drop-shadow(0 0 8px rgba(72, 219, 160, .95)); }
  100% { transform: scale(1); filter: drop-shadow(0 2px 2px rgba(42, 28, 9, .48)); }
}
@keyframes scarabScoreLoss {
  0% { transform: scale(1); filter: drop-shadow(0 2px 2px rgba(42, 28, 9, .48)); }
  35% { transform: scale(1.15) rotate(-4deg); filter: drop-shadow(0 0 8px rgba(211, 48, 85, .9)); }
  100% { transform: scale(1); filter: drop-shadow(0 2px 2px rgba(42, 28, 9, .48)); }
}
.super-mummy {
  position: fixed;
  z-index: 2147483602;
  left: 0;
  top: 50%;
  width: 48px;
  height: 78px;
  pointer-events: auto;
  cursor: pointer;
  user-select: none;
  opacity: 0;
  filter: drop-shadow(0 0 5px rgba(241, 201, 90, .55));
  animation-duration: var(--mummy-duration, 14s);
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
.super-mummy.walks-right {
  animation-name: mummyWalkRight;
}
.super-mummy.walks-left {
  animation-name: mummyWalkLeft;
}
.super-mummy.is-dissolving {
  --mummy-fall-angle: -78deg;
  cursor: default;
  transform-origin: 50% 100%;
  animation: mummyAgony 3.2s ease-in forwards;
}
.super-mummy.is-dissolving.facing-left {
  --mummy-fall-angle: 78deg;
}
.super-mummy.is-dissolving.falls-forward {
  --mummy-fall-angle: 78deg;
}
.super-mummy.is-dissolving.facing-left.falls-forward {
  --mummy-fall-angle: -78deg;
}
.super-mummy.is-cheering {
  cursor: default;
  transform-origin: 50% 100%;
  animation: mummyCheer 2.8s ease-out forwards;
}
.super-mummy.is-cheering .mummy-angry-mark {
  display: none;
}
.super-mummy.is-cheering .mummy-head {
  animation: mummyCheerHead .28s ease-in-out infinite alternate;
}
.super-mummy.is-cheering .mummy-body {
  animation: mummyCheerBody .28s ease-in-out infinite alternate;
}
.super-mummy.is-cheering .mummy-arm-front {
  animation: mummyCheerArmFront .32s ease-in-out infinite alternate;
}
.super-mummy.is-cheering .mummy-arm-back {
  animation: mummyCheerArmBack .32s ease-in-out infinite alternate;
}
.super-mummy.is-cheering .mummy-leg-front,
.super-mummy.is-cheering .mummy-leg-back {
  animation: mummyCheerLegs .28s ease-in-out infinite alternate;
}
.super-mummy.is-cheering .mummy-eyes::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 8px;
  width: 8px;
  height: 4px;
  border-bottom: 2px solid #6b4518;
  border-radius: 0 0 50% 50%;
}
.super-mummy.is-dissolving .mummy-head {
  animation: mummyPainHead .22s ease-in-out 2 alternate, mummyCrumble 1.25s 1.75s ease-in forwards;
}
.super-mummy.is-dissolving .mummy-body {
  animation: mummyPainBody .2s ease-in-out 2 alternate, mummyCrumble 1.3s 1.75s ease-in forwards;
}
.super-mummy.is-dissolving .mummy-arm,
.super-mummy.is-dissolving .mummy-leg {
  animation: mummyPainLimb .2s ease-in-out 2 alternate, mummyCrumble 1.1s 1.8s ease-in forwards;
}
.mummy-sand-grain {
  position: absolute;
  z-index: 7;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  pointer-events: none;
  opacity: 0;
  background: #c9a852;
  box-shadow: 0 0 3px rgba(241, 201, 90, .65);
  animation: mummySand 1.35s var(--sand-delay, 0s) ease-in forwards;
}
.super-anubis {
  z-index: 2147483603;
  width: 64px;
  height: 98px;
  filter: drop-shadow(0 0 7px rgba(220, 174, 55, .65));
}
.anubis-figure {
  position: absolute;
  inset: 0;
  transform-origin: 50% 100%;
}
.walks-left .anubis-figure,
.facing-left .anubis-figure {
  transform: scaleX(-1);
}
.anubis-head {
  position: absolute;
  z-index: 5;
  left: 17px;
  top: 13px;
  width: 30px;
  height: 29px;
  border: 2px solid #b98b27;
  border-radius: 48% 52% 42% 44%;
  background: linear-gradient(145deg, #302a22, #090909 70%);
}
.anubis-ear {
  position: absolute;
  z-index: 4;
  top: -1px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 25px solid #171512;
  filter: drop-shadow(0 -1px #b98b27);
}
.anubis-ear.ear-left {
  left: 15px;
  transform: rotate(-12deg);
}
.anubis-ear.ear-right {
  left: 35px;
  transform: rotate(12deg);
}
.anubis-eye {
  position: absolute;
  right: 4px;
  top: 9px;
  width: 6px;
  height: 3px;
  border-radius: 50%;
  background: #ffd65a;
  box-shadow: 0 0 6px #ffca35;
}
.anubis-snout {
  position: absolute;
  right: -14px;
  top: 13px;
  width: 21px;
  height: 10px;
  border: 2px solid #b98b27;
  border-left: 0;
  border-radius: 15% 80% 55% 10%;
  background: #11100e;
}
.anubis-body {
  position: absolute;
  z-index: 3;
  left: 16px;
  top: 39px;
  width: 33px;
  height: 36px;
  border: 2px solid #b98b27;
  border-radius: 20% 20% 8% 8%;
  background: linear-gradient(90deg, #171512, #342d22 50%, #0c0c0b);
  box-shadow: inset 0 7px #c59a35, inset 0 10px #315c65;
}
.anubis-arm,
.anubis-leg {
  position: absolute;
  z-index: 4;
  width: 9px;
  border: 2px solid #b98b27;
  border-radius: 999px;
  background: #171512;
  transform-origin: 50% 3px;
}
.anubis-arm {
  top: 43px;
  height: 35px;
}
.anubis-arm.arm-left { left: 10px; animation: mummyArmBack .48s ease-in-out infinite alternate; }
.anubis-arm.arm-right { left: 46px; animation: mummyArmFront .48s ease-in-out infinite alternate; }
.anubis-leg {
  top: 70px;
  height: 27px;
}
.anubis-leg.leg-left { left: 20px; animation: mummyLegBack .45s ease-in-out infinite alternate; }
.anubis-leg.leg-right { left: 37px; animation: mummyLegFront .45s ease-in-out infinite alternate; }
.anubis-health {
  position: absolute;
  z-index: 9;
  left: 7px;
  top: -13px;
  display: flex;
  gap: 3px;
}
.anubis-health i {
  display: block;
  width: 8px;
  height: 5px;
  border: 1px solid #7d5814;
  background: #f0c64f;
  box-shadow: 0 0 4px rgba(240, 198, 79, .85);
  transition: opacity .2s ease, transform .2s ease;
}
.anubis-health i.is-lost {
  opacity: .15;
  transform: scale(.35);
}
.super-anubis.is-hit .anubis-figure {
  animation: anubisHit .3s ease-out;
}
.super-anubis.is-dissolving .anubis-figure {
  animation: mummyCrumble 1.3s 1.75s ease-in forwards;
}
.super-anubis.is-cheering .anubis-health {
  display: none;
}
.super-anubis.is-cheering .anubis-figure {
  animation: mummyCheerBody .28s ease-in-out infinite alternate;
}
.super-anubis.is-cheering .anubis-head {
  animation: mummyCheerHead .28s ease-in-out infinite alternate;
}
.super-anubis.is-cheering .anubis-arm.arm-left {
  animation: mummyCheerArmBack .32s ease-in-out infinite alternate;
}
.super-anubis.is-cheering .anubis-arm.arm-right {
  animation: mummyCheerArmFront .32s ease-in-out infinite alternate;
}
.super-anubis.is-cheering .anubis-leg {
  animation: mummyCheerLegs .28s ease-in-out infinite alternate;
}
.super-medjed {
  z-index: 2147483603;
  width: 54px;
  height: 78px;
  filter: drop-shadow(0 4px 3px rgba(76, 54, 25, .22));
}
.medjed-body {
  position: absolute;
  z-index: 4;
  left: 4px;
  top: 0;
  width: 46px;
  height: 64px;
  border: 2px solid #e5dfce;
  border-radius: 50% 50% 18px 18px / 38% 38% 18px 18px;
  background: linear-gradient(100deg, #fff 0%, #fffdf7 58%, #eee8d8 100%);
  box-shadow: inset 7px 0 rgba(255, 255, 255, .8), inset -5px -4px rgba(203, 193, 168, .14);
  transform-origin: 50% 100%;
  animation: medjedFloat .7s ease-in-out infinite alternate;
}
.medjed-body::before,
.medjed-body::after {
  content: none;
}
.medjed-released-shell {
  position: fixed;
  z-index: 2147483604;
  margin: 0;
  pointer-events: none;
  transform-origin: 50% 80%;
  animation: medjedShellRelease 1.05s cubic-bezier(.2, .72, .25, 1) forwards !important;
}
.medjed-eye {
  position: absolute;
  top: 18px;
  width: 10px;
  height: 13px;
  border-radius: 50%;
  background: #8a431d;
  box-shadow: inset 0 -2px 0 rgba(75, 31, 13, .18);
}
.medjed-eye::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 2px;
  width: 3px;
  height: 9px;
  border-radius: 50%;
  background: #fffdf4;
}
.medjed-eye.eye-left {
  left: 9px;
}
.medjed-eye.eye-right {
  right: 9px;
}
.super-medjed.is-angry .mummy-angry-mark {
  display: block;
  left: auto;
  right: -5px;
  top: -13px;
  filter: drop-shadow(0 0 5px rgba(239, 41, 78, .95));
}
.medjed-mouth {
  display: none;
}
.medjed-leg {
  position: absolute;
  z-index: 2;
  bottom: -12px;
  width: 7px;
  height: 15px;
  border: 0;
  border-radius: 999px;
  background: #2c211a;
  transform-origin: 50% 2px;
}
.medjed-leg.leg-left {
  left: 11px;
  animation: mummyLegBack .45s ease-in-out infinite alternate;
}
.medjed-leg.leg-right {
  right: 11px;
  animation: mummyLegFront .45s ease-in-out infinite alternate;
}
.medjed-ray {
  display: none;
}
.medjed-ray.ray-left {
  left: -15px;
  transform: rotate(-8deg);
}
.medjed-ray.ray-right {
  right: -15px;
  transform: scaleX(-1) rotate(-8deg);
}
.walks-left .medjed-body,
.facing-left .medjed-body,
.walks-left .medjed-ray,
.facing-left .medjed-ray {
  scale: -1 1;
}
.super-mummy.super-medjed.is-dissolving {
  animation: medjedVanish 3.2s ease-in forwards;
}
.super-medjed.is-dissolving .medjed-body {
  animation: medjedSheetLift 3.05s ease-in forwards;
}
.super-medjed.is-dissolving .medjed-leg {
  animation: medjedLegHide .28s ease-in forwards;
}
.medjed-poison-haze {
  position: absolute;
  z-index: 2;
  left: -8px;
  top: 22px;
  width: 70px;
  height: 46px;
  border-radius: 50%;
  opacity: 0;
  background:
    radial-gradient(circle at 35% 58%, rgba(24, 5, 31, .82), transparent 42%),
    radial-gradient(circle at 68% 40%, rgba(92, 25, 119, .6), transparent 44%),
    radial-gradient(circle at 52% 72%, rgba(41, 8, 51, .72), transparent 55%);
  box-shadow:
    inset 0 0 14px rgba(115, 38, 139, .45),
    0 0 12px rgba(99, 28, 132, .38);
  filter: blur(4px);
  animation: medjedPoisonHaze 2.45s .35s ease-out forwards;
}
.medjed-poison-smoke {
  position: absolute;
  z-index: 6;
  width: 14px;
  height: 14px;
  border-radius: 48% 52% 44% 56%;
  background: radial-gradient(circle at 38% 35%, #70237d, #26072d 58%, rgba(12, 2, 16, .15) 74%);
  opacity: 0;
  filter: blur(2px);
  box-shadow: 0 0 8px rgba(115, 36, 137, .5);
  animation: medjedPoisonSmoke 1.8s var(--smoke-delay) ease-out forwards;
}
.medjed-poison-smoke::before,
.medjed-poison-smoke::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  background: inherit;
}
.medjed-poison-smoke::before { width: 10px; height: 10px; left: -5px; top: 6px; }
.medjed-poison-smoke::after { width: 9px; height: 9px; right: -4px; top: -3px; }
.curse-revealed .mummy-head,
.curse-revealed .mummy-body,
.curse-revealed .mummy-arm,
.curse-revealed .mummy-leg {
  animation: mummyCurseReveal .45s ease-out;
}
.super-medjed.is-cheering .medjed-body {
  animation: mummyCheerBody .28s ease-in-out infinite alternate;
}
.super-medjed.is-cheering .medjed-ray {
  animation: medjedRay .28s ease-in-out infinite alternate;
}
.mummy-head {
  position: absolute;
  z-index: 4;
  left: 12px;
  top: 0;
  width: 27px;
  height: 29px;
  border: 2px solid #a88634;
  border-radius: 45% 48% 38% 42%;
  background: repeating-linear-gradient(8deg, #ead99e 0 4px, #bfa65d 4px 6px);
  animation: mummyBob .48s ease-in-out infinite alternate;
}
.is-angry .mummy-head,
.is-angry .mummy-arm,
.is-angry .mummy-leg {
  border-color: #725c32;
  background: repeating-linear-gradient(10deg, #c3ad72 0 4px, #8f7846 4px 6px);
}
.is-angry .mummy-body {
  border-color: #725c32;
  background: #aa9156;
}
.is-angry .mummy-bandages {
  background: repeating-linear-gradient(-8deg, transparent 0 5px, rgba(205, 187, 126, .82) 5px 8px, rgba(74, 54, 25, .55) 8px 9px);
}
.mummy-angry-mark {
  display: none;
  position: absolute;
  z-index: 8;
  left: -11px;
  top: -13px;
  width: 21px;
  height: 21px;
  filter: drop-shadow(0 0 3px rgba(220, 30, 65, .85));
  transform-origin: 50% 50%;
}
.is-angry .mummy-angry-mark {
  display: block;
  animation: mummyAngryBreath 1.15s ease-in-out infinite alternate;
}
.mummy-angry-mark i {
  position: absolute;
  display: block;
  border: 0 solid #ef294e;
  filter: drop-shadow(0 0 1px #651020);
}
.mummy-angry-mark i:nth-child(1) {
  left: 5px;
  top: 0;
  width: 11px;
  height: 6px;
  border-bottom-width: 2px;
  border-radius: 0 0 50% 50%;
}
.mummy-angry-mark i:nth-child(2) {
  right: 0;
  top: 5px;
  width: 6px;
  height: 11px;
  border-left-width: 2px;
  border-radius: 50% 0 0 50%;
}
.mummy-angry-mark i:nth-child(3) {
  left: 5px;
  bottom: 0;
  width: 11px;
  height: 6px;
  border-top-width: 2px;
  border-radius: 50% 50% 0 0;
}
.mummy-angry-mark i:nth-child(4) {
  left: 0;
  top: 5px;
  width: 6px;
  height: 11px;
  border-right-width: 2px;
  border-radius: 0 50% 50% 0;
}
.mummy-eyes {
  position: absolute;
  left: 5px;
  top: 10px;
  width: 17px;
  height: 8px;
  background:
    radial-gradient(circle at 4px 50%, #17130c 0 2px, #f5c94f 2.5px 4px, transparent 4.5px),
    radial-gradient(circle at 13px 50%, #17130c 0 2px, #f5c94f 2.5px 4px, transparent 4.5px);
  filter: drop-shadow(0 0 3px rgba(245, 201, 79, .75));
}
.mummy-body {
  position: absolute;
  z-index: 3;
  left: 11px;
  top: 25px;
  width: 29px;
  height: 36px;
  border: 2px solid #9c803d;
  border-radius: 35% 42% 20% 20%;
  background: #d8c17b;
  transform: rotate(-3deg);
}
.mummy-bandages {
  position: absolute;
  inset: 3px 1px;
  background: repeating-linear-gradient(-8deg, transparent 0 5px, rgba(255, 245, 199, .9) 5px 8px, rgba(122, 94, 36, .45) 8px 9px);
}
.mummy-arm,
.mummy-leg {
  position: absolute;
  width: 9px;
  border: 2px solid #9c803d;
  border-radius: 999px;
  background: repeating-linear-gradient(10deg, #ead99e 0 4px, #bfa65d 4px 6px);
  transform-origin: 50% 3px;
}
.mummy-arm {
  z-index: 5;
  top: 29px;
  height: 34px;
}
.mummy-arm-front {
  left: 33px;
  animation: mummyArmFront .6s ease-in-out infinite alternate;
}
.mummy-arm-back {
  left: 8px;
  z-index: 2;
  animation: mummyArmBack .6s ease-in-out infinite alternate;
}
.mummy-leg {
  z-index: 2;
  top: 55px;
  height: 23px;
}
.mummy-leg-front {
  left: 27px;
  animation: mummyLegFront .55s ease-in-out infinite alternate;
}
.mummy-leg-back {
  left: 14px;
  animation: mummyLegBack .55s ease-in-out infinite alternate;
}
.mummy-shadow {
  position: absolute;
  left: 5px;
  bottom: -4px;
  width: 39px;
  height: 7px;
  border-radius: 50%;
  background: rgba(55, 42, 18, .2);
  filter: blur(2px);
  animation: mummyShadow .48s ease-in-out infinite alternate;
}
.walks-left .mummy-head,
.walks-left .mummy-body,
.walks-left .mummy-arm,
.walks-left .mummy-leg,
.facing-left .mummy-head,
.facing-left .mummy-body,
.facing-left .mummy-arm,
.facing-left .mummy-leg {
  transform: scaleX(-1);
}
@keyframes mummyWalkRight {
  0% { opacity: 0; transform: translate(-70px, 0); }
  6%, 92% { opacity: .82; }
  100% { opacity: 0; transform: translate(calc(100vw + 70px), var(--mummy-drift-y, 0)); }
}
@keyframes mummyWalkLeft {
  0% { opacity: 0; transform: translate(calc(100vw + 70px), 0); }
  6%, 92% { opacity: .82; }
  100% { opacity: 0; transform: translate(-70px, var(--mummy-drift-y, 0)); }
}
@keyframes mummyBob {
  from { translate: 0 0; }
  to { translate: 0 2px; }
}
@keyframes mummyArmFront {
  from { rotate: -34deg; }
  to { rotate: 30deg; }
}
@keyframes mummyArmBack {
  from { rotate: 28deg; }
  to { rotate: -30deg; }
}
@keyframes mummyLegFront {
  from { rotate: -24deg; }
  to { rotate: 24deg; }
}
@keyframes mummyLegBack {
  from { rotate: 22deg; }
  to { rotate: -22deg; }
}
@keyframes mummyShadow {
  from { opacity: .35; transform: scaleX(.8); }
  to { opacity: .18; transform: scaleX(1); }
}
@keyframes medjedFloat {
  from { translate: 0 0; }
  to { translate: 0 -3px; }
}
@keyframes medjedRay {
  from { opacity: .25; width: 14px; }
  to { opacity: .58; width: 24px; }
}
@keyframes medjedSheetLift {
  0% { opacity: 1; transform: translate(0, 0) rotate(0) scale(1); }
  18% { transform: translate(-2px, 1px) rotate(-4deg); }
  32% { transform: translate(2px, 1px) rotate(4deg); }
  48% { opacity: 1; transform: translate(0, 3px) rotate(0) scale(1, .96); }
  78% { opacity: .88; transform: translate(2px, 10px) rotate(7deg) scale(.92, .78); }
  100% { opacity: 0; transform: translate(3px, 21px) rotate(10deg) scale(.78, .3); filter: blur(3px); }
}
@keyframes medjedShellRelease {
  0% { opacity: 1; transform: translate(0, 0) rotate(0) scale(1); filter: drop-shadow(0 3px 3px rgba(76, 54, 25, .22)); }
  35% { opacity: 1; transform: translate(-2px, -18px) rotate(-5deg) scale(1.03); }
  72% { opacity: .72; transform: translate(5px, -43px) rotate(9deg) scale(.94, 1.06); }
  100% { opacity: 0; transform: translate(9px, -66px) rotate(17deg) scale(.82, 1.1); filter: blur(2px); }
}
@keyframes medjedLegHide {
  to { opacity: 0; transform: scaleY(.1); }
}
@keyframes medjedPoisonHaze {
  0% { opacity: 0; transform: scale(.55); }
  30%, 72% { opacity: .72; transform: scale(1); }
  100% { opacity: 0; transform: translateY(-8px) scale(1.12); filter: blur(7px); }
}
@keyframes medjedPoisonSmoke {
  0% { opacity: 0; transform: translate(0, 7px) scale(.5); }
  24% { opacity: .8; }
  100% { opacity: 0; transform: translate(var(--smoke-x), var(--smoke-y)) scale(var(--smoke-scale)); filter: blur(4px); }
}
@keyframes mummyCurseReveal {
  0% { opacity: 0; scale: .62; filter: blur(3px); }
  55% { opacity: 1; scale: 1.1; filter: blur(0); }
  100% { opacity: 1; scale: 1; filter: none; }
}
@keyframes medjedVanish {
  0%, 78% { opacity: 1; }
  100% { opacity: 0; }
}
@keyframes mummyAngryBreath {
  from {
    opacity: .7;
    transform: scale(.88);
    filter: drop-shadow(0 0 2px rgba(220, 30, 65, .55));
  }
  to {
    opacity: 1;
    transform: scale(1.08);
    filter: drop-shadow(0 0 6px rgba(255, 45, 82, .95));
  }
}
@keyframes anubisHit {
  0% { translate: 0 0; filter: brightness(1); }
  25% { translate: -5px 0; filter: brightness(2.2) sepia(1); }
  50% { translate: 5px -2px; }
  75% { translate: -3px 1px; }
  100% { translate: 0 0; filter: brightness(1); }
}
@keyframes mummyCheer {
  0% { opacity: .82; transform: translateY(0) scale(1); }
  12% { opacity: 1; transform: translateY(-17px) scale(1.04); }
  24% { transform: translateY(0) scale(.98, 1.02); }
  38% { transform: translateY(-20px) scale(1.06); }
  50% { transform: translateY(0) scale(.98, 1.02); }
  64% { transform: translateY(-15px) scale(1.03); }
  76% { opacity: 1; transform: translateY(0) scale(1); }
  100% { opacity: 0; transform: translateY(-8px) scale(.9); }
}
@keyframes mummyCheerHead {
  from { translate: -1px 0; rotate: -6deg; }
  to { translate: 1px -2px; rotate: 6deg; }
}
@keyframes mummyCheerBody {
  from { rotate: -4deg; }
  to { rotate: 4deg; }
}
@keyframes mummyCheerArmFront {
  from { rotate: 145deg; }
  to { rotate: 175deg; }
}
@keyframes mummyCheerArmBack {
  from { rotate: -145deg; }
  to { rotate: -175deg; }
}
@keyframes mummyCheerLegs {
  from { rotate: -8deg; }
  to { rotate: 8deg; }
}
@keyframes mummyAgony {
  0% { opacity: .9; transform: rotate(0) scale(1); filter: drop-shadow(0 0 5px rgba(241, 201, 90, .55)); }
  18% { transform: rotate(-8deg) translate(-3px, -1px); }
  32% { opacity: 1; transform: rotate(7deg) translate(3px, 0); filter: drop-shadow(0 0 13px rgba(255, 210, 76, .95)); }
  44% { opacity: 1; transform: rotate(0) translate(0, 0); }
  72% { opacity: .95; transform: rotate(var(--mummy-fall-angle)) translateY(5px); }
  84% { opacity: .8; transform: rotate(var(--mummy-fall-angle)) translateY(10px) scaleY(.82); }
  100% { opacity: 0; transform: rotate(var(--mummy-fall-angle)) translateY(22px) scale(.72, .18); filter: sepia(1) blur(3px); }
}
@keyframes mummyPainHead {
  from { translate: -2px 0; rotate: -7deg; }
  to { translate: 2px 1px; rotate: 8deg; }
}
@keyframes mummyPainBody {
  from { translate: -2px 0; rotate: -4deg; }
  to { translate: 2px 0; rotate: 5deg; }
}
@keyframes mummyPainLimb {
  from { rotate: -45deg; }
  to { rotate: 48deg; }
}
@keyframes mummyCrumble {
  from { opacity: 1; filter: saturate(1); }
  to { opacity: 0; translate: 0 20px; filter: sepia(1) blur(2px); }
}
@keyframes mummySand {
  0% { opacity: 0; transform: translate(0, 0) scale(1); }
  18% { opacity: .95; }
  100% { opacity: 0; transform: translate(var(--sand-x), var(--sand-y)) scale(.35); }
}
.super-eye-effect {
  position: fixed;
  z-index: 2147483647;
  left: 0;
  top: 0;
  width: 112px;
  height: 112px;
  pointer-events: none;
  transform: translate(-50%, -50%);
  animation: superEyeReveal .9s ease-out forwards;
}
.super-eye-halo {
  position: absolute;
  inset: 8px;
  border: 1px solid rgba(255, 230, 139, .8);
  border-radius: 50%;
  box-shadow: 0 0 12px #fff4ba, 0 0 30px rgba(241, 201, 90, .95), inset 0 0 16px rgba(255, 230, 139, .65);
  animation: superEyeHalo .9s ease-out forwards;
}
.super-eye-symbol {
  position: absolute;
  left: 25px;
  top: 43px;
  width: 64px;
  height: 30px;
  border: 3px solid #ffe48a;
  border-radius: 85% 18% 85% 18%;
  background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, .92) 0 8%, rgba(241, 201, 90, .24) 42%, rgba(123, 88, 22, .18) 68%);
  box-shadow: 0 0 7px #fff, 0 0 18px #f1c95a, 0 0 34px rgba(217, 169, 46, .9);
  transform: skewX(-12deg);
}
.super-eye-brow {
  position: absolute;
  left: 25px;
  top: 31px;
  width: 67px;
  height: 15px;
  border-top: 4px solid #ffe48a;
  border-radius: 50%;
  filter: drop-shadow(0 0 5px #f1c95a);
  transform: rotate(5deg);
}
.super-eye-pupil {
  position: absolute;
  left: 18px;
  top: 2px;
  width: 22px;
  height: 22px;
  border: 3px solid #fff1ae;
  border-radius: 50%;
  background: #5a3a08;
  box-shadow: 0 0 5px #fff, 0 0 15px #ffd75f;
}
.super-eye-pupil::after {
  content: "";
  position: absolute;
  left: 5px;
  top: 5px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 7px #fff;
}
.super-eye-mark {
  position: absolute;
  left: 5px;
  top: 24px;
  width: 13px;
  height: 31px;
  border-left: 5px solid #ffe48a;
  border-radius: 48% 0 0 80%;
  filter: drop-shadow(0 0 5px #f1c95a);
  transform: skewX(7deg);
}
.super-eye-tail {
  position: absolute;
  left: 28px;
  top: 24px;
  width: 58px;
  height: 35px;
  border-bottom: 4px solid #ffe48a;
  border-radius: 0 0 75% 45%;
  filter: drop-shadow(0 0 5px #f1c95a);
  transform: rotate(14deg);
}
.super-eye-tail::after {
  content: "";
  position: absolute;
  right: -2px;
  bottom: -5px;
  width: 13px;
  height: 13px;
  border: 3px solid #ffe48a;
  border-left-color: transparent;
  border-radius: 50%;
}
.super-ankh-symbol {
  position: absolute;
  left: 34px;
  top: 25px;
  width: 44px;
  height: 69px;
  filter: drop-shadow(0 0 5px #fff4ba) drop-shadow(0 0 12px #f1c95a);
}
.super-ankh-loop {
  position: absolute;
  left: 10px;
  top: 0;
  width: 24px;
  height: 31px;
  border: 4px solid #ffe48a;
  border-radius: 50%;
}
.super-ankh-cross {
  position: absolute;
  left: 1px;
  top: 32px;
  width: 42px;
  height: 4px;
  border-radius: 50%;
  background: #ffe48a;
  box-shadow: 0 0 7px #fff, 0 0 15px #f1c95a;
}
.super-ankh-stem {
  position: absolute;
  left: 20px;
  top: 28px;
  width: 4px;
  height: 41px;
  border-radius: 50%;
  background: #ffe48a;
  box-shadow: 0 0 7px #fff, 0 0 15px #f1c95a;
}
@keyframes superEyeReveal {
  0% { opacity: 0; transform: translate(-50%, -50%) scale(.22); }
  18% { opacity: 1; transform: translate(-50%, -50%) scale(.82); }
  62% { opacity: 1; transform: translate(-50%, -50%) scale(.8); }
  100% { opacity: 0; transform: translate(-50%, -50%) scale(1.05); }
}
@keyframes superEyeHalo {
  0% { opacity: 0; transform: scale(.35) rotate(0deg); }
  25% { opacity: 1; }
  100% { opacity: 0; transform: scale(1.35) rotate(90deg); }
}
.laser-pointer-effect {
  position: fixed;
  z-index: 2147483647;
  top: 0;
  left: 0;
  width: 96px;
  height: 96px;
  pointer-events: none;
  transform: translate(-50%, -50%);
}
.laser-pointer-hold-dot {
  position: fixed;
  z-index: 2147483647;
  left: 0;
  top: 0;
  width: 14px;
  height: 14px;
  pointer-events: none;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: #ff1d1d;
  box-shadow: 0 0 6px #fff, 0 0 16px rgba(255, 0, 0, .95), 0 0 32px rgba(255, 0, 0, .7);
}
.laser-pointer-trail-canvas {
  position: fixed;
  z-index: 2147483646;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
}
body.laser-pointer-active,
body.laser-pointer-active * {
  user-select: none !important;
  -webkit-user-drag: none !important;
}
.laser-pointer-effect,
.laser-pointer-effect::before,
.laser-pointer-effect::after,
.laser-pointer-effect span {
  animation-duration: .58s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
}
.laser-pointer-effect::before {
  content: "";
  position: absolute;
  inset: 27px;
  border: 2px solid rgba(255, 20, 20, .95);
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(255, 0, 0, .95), 0 0 22px rgba(255, 0, 0, .45);
  animation-name: laserRing;
}
.laser-pointer-effect::after {
  content: "";
  position: absolute;
  left: 46px;
  top: -9px;
  width: 4px;
  height: 54px;
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0), #fff 20%, #ff1d1d 45%, rgba(255, 0, 0, 0));
  box-shadow: 0 0 8px rgba(255, 0, 0, .95), 0 0 18px rgba(255, 0, 0, .55);
  transform: rotate(38deg);
  transform-origin: 50% 100%;
  animation-name: laserBeam;
}
.laser-pointer-effect span {
  position: absolute;
  left: 42px;
  top: 42px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ff1d1d;
  box-shadow: 0 0 6px #fff, 0 0 14px rgba(255, 0, 0, .95), 0 0 28px rgba(255, 0, 0, .7);
  animation-name: laserDot;
}
@keyframes laserRing {
  0% {
    opacity: 1;
    transform: scale(.25);
  }
  100% {
    opacity: 0;
    transform: scale(1.75);
  }
}
@keyframes laserBeam {
  0% {
    opacity: 0;
    transform: rotate(38deg) scaleY(.2);
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(38deg) scaleY(1.15) translateY(-10px);
  }
}
@keyframes laserDot {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(.45);
  }
}
::placeholder {
  color: rgb(165, 165, 165);
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: rgb(165, 165, 165);
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: rgb(165, 165, 165);
}
/*@media screen and (max-width: 450px) {
	.main-info {
    margin: 110px 0 0 0;
  }
}*/
</style>
